import { Box, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

import {
  background,
  roads,
  trees,
} from "../../assets/images";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { ChevronRightRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../CustomButton";

const HeroSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();


  const slides = [
    {
      image: background,
      title: "Lifelong Journeys Unlocking Potential",
      subtitle:
        "EAGLE is an acronym that stands for Enhanced Access to Great Learning Experiences. Each word holds a key to part of our vision and mission. ",
      buttonText: "Learn More",
      link: "/about",
    },
    {
      image: roads,
      title: "Real stories, Real Impact",
      subtitle:
        "Learners, mentors, coaches, teachers, families: EAGLE touches many lives and meets individuals where they are at in both Zimbabwe and Zambia. ",
      buttonText: "Meet our People",
      link: "/sites",
    },
    {
      image: trees,
      title: "Experience For All Ages",
      subtitle:
        "Learning is a lifelong adventure. Whether young or old, there are always things we can learn and experiences we can have that shape who we are.",
      buttonText: "Journey with Us",
      link: "/donate",
    },
  ];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 9000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          loop={true}
          style={{ width: "100%", height: "100%" }}
          speed={1500}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <Box
                component="img"
                src={slide.image}
                alt={`Slide ${index}`}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <Box
          sx={{
            width: "inherit",
            height: {xs: "112vh", md: "inherit"},
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={activeIndex}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                padding: "20px",
                width: { xs: "100%", md: "80%" },
                maxWidth: "700px",
              }}
            >
              <Typography
                variant="h1"
                gutterBottom
                sx={{
                  color: "#fff",
                  fontSize: { xs: "2rem", md: "3rem" },
                  alignSelf: "center",
                  width: { xs: "100%", md: "80%" },
                }}
              >
                {slides[activeIndex].title}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  my: 3,
                  color: "#fff",
                }}
              >
                {slides[activeIndex].subtitle}
              </Typography>

              <CustomButton onClick={() => navigate(slides[activeIndex].link)}>
                <Typography>{slides[activeIndex].buttonText}</Typography>
                <ChevronRightRounded />
              </CustomButton>
            </motion.div>
          </AnimatePresence>
        </Box>
      </Box>
    </motion.div>
  );
};

export default HeroSection;
